'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
import { TrackingStatusCodes } from '../../lib/Constants';
export default new Record({
  statuses: ImmutableSet(),
  code: TrackingStatusCodes.TRACKED,
  lastAttempted: null
});